<template lang="pug">
v-row
	v-col(cols="12" sm="6" md="4" v-for="item in items" v-if="item.stats.webcamCount > 0 && item.webcamLarge" :key="item.id")
		v-card(tile flat)
			nuxt-link(:to="localePath({name:`${item.__typename.toLowerCase()}s-${item.__typename.toLowerCase()}-webcams`, params: {[item.__typename.toLowerCase()]: item.slug}})")
				v-img.pip(:src="item.webcamLarge.preview" :aspect-ratio="16/9")
					v-card.small(v-if="item.webcamSmall && item.webcamLarge && item.webcamSmall.id != item.webcamLarge.id" )
						v-img.pb-2.br-2(:src="item.webcamSmall.preview" :aspect-ratio="16/9")
				| {{$tc('webcam_list.item_label.{area}{count}', item.stats.webcamCount, {area: item.name, count: item.stats.webcamCount})}}
</template>

<style lang="sass">
.pip .v-responsive__content
	position: relative
	.small
		right: 5px !important
		bottom: 5px !important
		position: absolute !important
		width: 33% !important
		height: 33% !important
		border: 1px solid var(--v-border-base) !important
		overflow: hidden
</style>

<script>
export default {
	props: {
		items: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	data() {
		return {};
	}
};
</script>
